import { makeAutoObservable } from "mobx";
import {ModalPayload, ModalState, ModalType} from "@/entities/modals/types";
import {RootStore} from "@/app/providers/StoreProvider";

export class ModalStore {
    stack: ModalState[] = [];

    constructor(private rootStore:RootStore) {
        makeAutoObservable(this);
    }

    //Текущая модалка (верх стека)
    get currentModal() {
        return this.stack[this.stack.length - 1] ?? null;
    }

    //Есть ли открытые модалки
    get isOpen() {
        return this.stack.length > 0;
    }

    //Открыть модалку (пуш в стек)
    open<T extends ModalType>(type: T, payload: ModalPayload<T>) {
        this.stack.push({ type, payload } as ModalState);
    }

    //Закрыть текущую
    close() {
        this.stack.pop();
    }

    //Закрыть все
    closeAll() {
        this.stack = [];
    }

    //Заменить текущую (без изменения глубины стека)
    replace<T extends ModalType>(type: T, payload: ModalPayload<T>) {
        if (this.stack.length === 0) {
            this.open(type, payload);
            return;
        }

        this.stack[this.stack.length - 1] = { type, payload } as ModalState;
    }
}
